


















import { Component, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import VaultInjectorMixin from "@/mixins/vaultInjectorMixin";
import Context from "@/mixins/context";

// Types
import { IVaultAsset } from "@/models/vaultAssets";

@Component({
  components: {
    "vault-asset-dropdown-control": () =>
      import("@/components/app/global/vault/vaultAssetDropdownControl.vue")
  }
})
export default class VaultNoteItem extends Mixins(VaultInjectorMixin, Context) {
  // Props

  @Prop({ default: null })
  public note!: IVaultAsset;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: false })
  public isLoading!: boolean;

  // Methods

  public async updatePinned() {
    if (this.isDisabled) return;

    this.$vaultMethods.updateVaultAsset(this.note.id, {
      pinned: !this.note.pinned
    });
  }

  // Computed

  public get showSkeletons() {
    return _.isNull(this.note);
  }

  public get isHiddenFromClient() {
    return !(this.note?.visible_for_client ?? true);
  }

  public get noteProps() {
    if (this.showSkeletons)
      return {
        isLoading: this.isLoading,
        showSkeletons: this.showSkeletons
      };

    return {
      clientId: this.note.client_id,
      contractProduct:
        !this.vaultData.contractProductId && this.note.contract_product
          ? this.note.contract_product
          : undefined,
      datetime: this.note.updated_at,
      isDisabled: this.isDisabled,
      isLoading: this.isLoading,
      isPinned: this.note.pinned,
      note: this.note.note,
      showSkeletons: this.showSkeletons,
      updatePinned: this.updatePinned
    };
  }
}
